"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.giveUp = exports.giveUpAction = exports.GIVE_UP = void 0;
exports.GIVE_UP = 'GIVE_UP';
exports.giveUpAction = { type: exports.GIVE_UP };
function giveUp(state) {
    return __assign(__assign({}, state), { playerId: undefined });
}
exports.giveUp = giveUp;
